import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Conversation} from '../../domain/conversation';
import {ConversationService} from '../../service/chat/conversation.service';
import {PageStateService} from '../../../core/service/page-state.service';

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],

    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatComponent implements OnInit {

    conversation: Conversation = null;

    constructor(
        private conversationService: ConversationService,
        // private cd: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.conversationService.unsetSelectedConversation();
    }

    public showConversation(c: Conversation) {
        this.conversation = c;
        // this.cd.markForCheck();
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/chat/chat.component.ts